export const APP_SAVING_ACTIVATE = 'APP_SAVING_ACTIVATE'
export const APP_SAVING_DEACTIVATE = 'APP_SAVING_DEACTIVATE'

export const activateAppSaving = initiator => ({ type: APP_SAVING_ACTIVATE, initiator })
export const deactivateAppSaving = initiator => ({ type: APP_SAVING_DEACTIVATE, initiator })
